import { selfAxios } from "../../../../axios/selfAxios.js";
async function postGetAttributeDataList(params) {
  const { data } = await selfAxios.post(`/bsplatform/attributeDefinition/getAttributeDataList`, params, { _cache: true });
  return data;
}
export { postGetAttributeDataList };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/bsplatform/attributeDefinition/getAttributeDataList/post.js